import MetricCategoryItem, { MetricCategoryItemStrings } from '../enums/MetricCategoryItem'

export const STAR_RATING_FILTER_OPTIONS = [
  MetricCategoryItem.ONE_STAR,
  MetricCategoryItem.TWO_STAR,
  MetricCategoryItem.THREE_STAR,
  MetricCategoryItem.FOUR_STAR,
  MetricCategoryItem.FIVE_STAR,
  MetricCategoryItem.NO_RESPONSE_STAR
]

export const SURVEY_SCORE_FILTER_OPTIONS = [
  MetricCategoryItem.NO_SCORE,
  MetricCategoryItem.ONE_SCORE,
  MetricCategoryItem.TWO_SCORE,
  MetricCategoryItem.THREE_SCORE,
  MetricCategoryItem.FOUR_SCORE,
  MetricCategoryItem.FIVE_SCORE,
  MetricCategoryItem.SIX_SCORE,
  MetricCategoryItem.SEVEN_SCORE,
  MetricCategoryItem.EIGHT_SCORE,
  MetricCategoryItem.NINE_SCORE,
  MetricCategoryItem.TEN_SCORE,
  MetricCategoryItem.NO_RESPONSE_SURVEY
]

export const NET_PROMOTER_SCORE_OPTIONS = [
  MetricCategoryItem.PROMOTER,
  MetricCategoryItem.PASSIVE,
  MetricCategoryItem.DETRACTOR,
  MetricCategoryItem.NO_RESPONSE_NPS
]

export const STAR_RATING_COUNT_OPTIONS = [
  MetricCategoryItem.ONE_STAR,
  MetricCategoryItem.TWO_STAR,
  MetricCategoryItem.THREE_STAR,
  MetricCategoryItem.FOUR_STAR,
  MetricCategoryItem.FIVE_STAR
]

export const SURVEY_SCORE_COUNT_OPTIONS = [
  MetricCategoryItem.NO_SCORE,
  MetricCategoryItem.ONE_SCORE,
  MetricCategoryItem.TWO_SCORE,
  MetricCategoryItem.THREE_SCORE,
  MetricCategoryItem.FOUR_SCORE,
  MetricCategoryItem.FIVE_SCORE,
  MetricCategoryItem.SIX_SCORE,
  MetricCategoryItem.SEVEN_SCORE,
  MetricCategoryItem.EIGHT_SCORE,
  MetricCategoryItem.NINE_SCORE,
  MetricCategoryItem.TEN_SCORE
]

export const SURVEY_SCORE_GROUP_OPTIONS = [
  MetricCategoryItem.TEN_SCORE,
  MetricCategoryItem.HIGH_SCORE,
  MetricCategoryItem.MEDIUM_SCORE,
  MetricCategoryItem.LOW_SCORE,
  MetricCategoryItem.NO_SCORE
]

export const getLabel = (type: MetricCategoryItemStrings) => {
  switch (type) {
    case MetricCategoryItem.TEN_SCORE:
      return '10'
    case MetricCategoryItem.NINE_SCORE:
      return '9'
    case MetricCategoryItem.EIGHT_SCORE:
      return '8'
    case MetricCategoryItem.SEVEN_SCORE:
      return '7'
    case MetricCategoryItem.SIX_SCORE:
      return '6'
    case MetricCategoryItem.FIVE_SCORE:
      return '5'
    case MetricCategoryItem.FOUR_SCORE:
      return '4'
    case MetricCategoryItem.THREE_SCORE:
      return '3'
    case MetricCategoryItem.TWO_SCORE:
      return '2'
    case MetricCategoryItem.ONE_SCORE:
      return '1'
    case MetricCategoryItem.NO_SCORE:
      return '0'
    default:
      return null
    // TODO: Where is "nb.ui.message" ?
    // case MetricCategoryItem.PROMOTER:
    //   return nb.ui.message.measureType({ measureType: type }) + ' (9-10)'
    // case MetricCategoryItem.PASSIVE:
    //   return nb.ui.message.measureType({ measureType: type }) + ' (7-8)'
    // case MetricCategoryItem.DETRACTOR:
    //   return nb.ui.message.measureType({ measureType: type }) + ' (0-6)'
    // default:
    //   return nb.ui.message.measureType({ measureType: type })
  }
}

export const getValue = (type: MetricCategoryItemStrings) => {
  switch (type) {
    case MetricCategoryItem.ONE_STAR:
      return 1
    case MetricCategoryItem.TWO_STAR:
      return 2
    case MetricCategoryItem.THREE_STAR:
      return 3
    case MetricCategoryItem.FOUR_STAR:
      return 4
    case MetricCategoryItem.FIVE_STAR:
      return 5
    case MetricCategoryItem.NO_RESPONSE_STAR:
      return -1
    case MetricCategoryItem.TEN_SCORE:
      return 10
    case MetricCategoryItem.NINE_SCORE:
      return 9
    case MetricCategoryItem.EIGHT_SCORE:
      return 8
    case MetricCategoryItem.SEVEN_SCORE:
      return 7
    case MetricCategoryItem.SIX_SCORE:
      return 6
    case MetricCategoryItem.FIVE_SCORE:
      return 5
    case MetricCategoryItem.FOUR_SCORE:
      return 4
    case MetricCategoryItem.THREE_SCORE:
      return 3
    case MetricCategoryItem.TWO_SCORE:
      return 2
    case MetricCategoryItem.ONE_SCORE:
      return 1
    case MetricCategoryItem.NO_SCORE:
      return 0
    case MetricCategoryItem.NO_RESPONSE_SURVEY:
      return -1
    default:
      return 0
  }
}
